<template>
    <div class="text-center">
        <v-dialog
            :value="dialog"
            fullscreen
            persistent
        >
            <v-card >
                <v-card-title class="headline grey lighten-2 py-4">
                    <span class=" policy-title">
                        <v-icon class="warning--text mr-2 mb-1" size="30">
                            mdi-alert
                        </v-icon>
                        <strong>
                            AVISO DE PRIVACIDAD INTEGRAL PARA PROVEEDORES
                        </strong>
                    </span  >
                </v-card-title>

                <v-card-text class="policy-text title py-4 px-4">
                    En cumplimiento a las disposiciones legales relacionadas con la Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), así como por las disposiciones legales que le son aplicables, <strong>JB SINIESTROS S.A. DE C.V.</strong> (en lo sucesivo, <strong>“JB SINIESTROS”</strong>) con domicilio en 39 poniente 3515, piso 5, oficina 1, Colonia las Animas, Puebla, Puebla, Código Postal 72400, hace de su conocimiento que es responsable del tratamiento de sus datos personales, del uso que se le dé a los mismos y de su protección.<br>

                    Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, <strong>“JB SINIESTROS”</strong>, recabará y someterá a tratamiento las siguientes categorías de datos personales:<br><br>
                    <ul>
                        <li v-for="(point, index) in dataPoints['personalData']" :key="index"  >{{ point }}</li>
                    </ul><br>

                    <strong>“JB SINIESTROS”</strong>tratará sus datos personales antes descritos para realizar las siguientes<br><br>

                    <strong class="headline font-weight-bold">FINALIDADES PRIMARIAS</strong>:<br><br>

                    <ul>
                        <li v-for="(point, index) in dataPoints['primaryPurposes']" :key="index"  >{{ point }}</li>
                    </ul><br>

                    <strong class="headline font-weight-bold">FINALIDADES SECUNDARIAS:</strong><br><br>

                    <ul>
                        <li v-for="(point, index) in dataPoints['secondaryPurposes']" :key="index"  >{{ point }}</li>
                    </ul><br>

                    Tratándose de las finalidades primarias, el proveedor no podrá negar o revocar su consentimiento, así como oponerse al tratamiento de sus datos personales, en razón de que dan origen a la relación que mantiene con <strong>“JB SINIESTROS”</strong>.<br>

                    En caso de que no desee que sus datos personales sean tratados para estos fines secundarios, desde este momento Usted nos puede comunicar lo anterior a través del siguiente mecanismo:<br>

                    Vía mensajería al domicilio  ubicado en 39 poniente 3515, piso 5, oficina 1, Colonia las Animas, Puebla, Puebla, Código Postal 72400 o escribiéndonos al correo electrónico <a href="mailto:proveedores@jbge.com.mx">proveedores@jbge.com.mx</a><br>

                    La negativa para el uso de sus datos personales para estas finalidades secundarias no podrá ser un motivo para que le neguemos los servicios y productos que solicita o contrata con nosotros.<br>

                    En caso de haber proporcionado a <strong>“JB SINIESTROS”</strong> sus datos en forma personal o directa, podrá hacerlo en cualquier momento, cuando el aviso de privacidad no se haga del conocimiento de Usted de manera directa o personal, Usted cuenta con un plazo de cinco días hábiles para que, de ser el caso, manifieste su negativa para el tratamiento de sus datos personales con respecto a las finalidades que no son necesarias, ni dieron origen a la relación jurídica con nosotros.<br>

                    Para las finalidades señaladas en el presente Aviso de Privacidad, podemos recabar sus datos personales de distintas formas: cuando usted nos lo proporciona directamente; cuando visita nuestro sitio de Internet y cuando obtenemos información a través de otras fuentes que están permitidas por la Ley.<br>

                    <br><strong class="headline font-weight-bold">TRANSFERENCIAS DE DATOS PERSONALES.</strong><br><br>

                    Únicamente se realizan transferencias de los datos personales a organismos públicos; administraciones públicas federales, estatales y/o municipales; comisiones; institutos, entidades reguladoras; autoridades judiciales o administrativas; entidades gubernamentales nacionales y/o extranjeras (autoridades competentes) para cumplir con las disposiciones legales correspondientes, así como para el esclarecimiento de incidentes o ejercicio de algún derecho, por tanto y de acuerdo al artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de Particulares para dicha transferencia no se requiere del consentimiento del titular.<br>

                    En caso de que realicemos alguna transferencia adicional que requiera su consentimiento expreso, se recabará el mismo previamente.<br>

                    <br><strong class="headline font-weight-bold">MEDIOS PARA EJERCER DERECHOS ARCO</strong><br><br>

                    Usted podrá ejercer cualquiera de los derechos de acceso, rectificación, cancelación u oposición (“Derechos ARCO”) así como revocar su consentimiento para el tratamiento de sus datos personales, mediante un escrito con atención al Departamento de Protección de Datos Personales mediante correo electrónico a la dirección <a href="mailto:proveedores@jbge.com.mx">proveedores@jbge.com.mx</a><br>

                    Además del ejercicio de sus derechos de Revocación o ARCO, usted podrá limitar el uso o divulgación de sus datos personales, mediante su inscripción en el Registro Público de Usuarios Personas Físicas (REUS).<br>

                    <br><strong class="headline font-weight-bold">MEDIDAS DE SEGURIDAD</strong><br><br>

                    <strong>“JB SINIESTROS”</strong> implementa medidas administrativas, técnicas y físicas necesarias para proteger sus datos personales contra daño, pérdida, alteración, destrucción o uso, acceso o tratamiento no autorizado, de conformidad con la normativa aplicable.<br>

                    <strong>“JB SINIESTROS”</strong> en sus sitios Web utiliza cookies para grabar la información de la sesión, tales como información específica sobre qué páginas visitó el usuario, pero dicha información es utilizada sobre una base anónima y agregada de tal manera que no podrá ser identificado en ella.<br>

                    Los sitios pueden permitir emitir publicidad o la ejecución de funciones de terceros que envían "cookies" al equipo de cómputo de los usuarios. Mediante el uso de estas "cookies" no se identifica personalmente a los usuarios, únicamente a su equipo de cómputo.<br>

                    Para cualquier asunto o duda relacionada con este Aviso de Privacidad, puede contactarnos al correo electrónico <a href="mailto:proveedores@jbge.com.mx">proveedores@jbge.com.mx</a>, o bien, al teléfono 222 670 6222.<br>

                    El presente Aviso de Privacidad podrá ser modificado o actualizado de manera semestral, con motivo de cambios legislativos, políticas internas o nuevos requerimientos para la prestación de servicios. Dichas actualizaciones se comunicarán a los titulares mediante llamada telefónica o mensajería instantánea, al número o medio de contacto proporcionado por el titular.<br>

                    Al proporcionar sus datos personales por cualquier medio, usted otorga su consentimiento expreso para que <strong>“JB SINIESTROS”</strong> los trate conforme a lo previsto en el presente Aviso de Privacidad.<br>

                    Fecha de última actualización del presente Aviso de Privacidad: 08 de octubre de 2025.<br>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="justify-end">
                    <v-btn
                        class="submit-btn"
                        color="green"
                        block
                        @click="submit"
                    >
                        Acepto
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>

const personalData = [
  'Datos de identificación',
  'Datos de contacto',
  'Datos patrimoniales o financieros',
  'Datos laborales',
  'Datos bancarios'
]
const primaryPurposes = [
  'Identificación y conocimiento de los proveedores, validación de su identidad y registro de sus datos para efectos de identificación del servicio contratado.',
  'Efectuar pagos por servicios o productos proporcionados.',
  'Realizar procesos de facturación y cumplimiento de obligaciones fiscales.',
  'Llevar a cabo evaluaciones de terceros o proveedores respecto a su desempeño, calidad, cumplimiento y confiabilidad.',
  'Mantener comunicación constante con proveedores, aliados comerciales y personal relacionado.',
  'Integrar, actualizar y conservar expedientes administrativos y de proveedores, así como la documentación relacionada con contratos o servicios.',
  'Dar cumplimiento a obligaciones regulatorias emitidas por parte de las autoridades competentes, así como atender a sus requerimientos.',
  'Recibir y dar seguimiento a las solicitudes para el ejercicio de los Derechos de los Titulares.',
  'Participar en procesos de auditoría o control interno.'
]

const secondaryPurposes = [
  'Campañas publicitarias y/o corporativas o comunicaciones de la compañía, mismas que pueden ser de manera personal, directa y/o a través del uso de, incluso sus, redes sociales.',
  'Para realizar encuestas de opinión, estudios del mercado de trabajo y/o encuestas relacionadas con la empresa.',
  'Con fines de mercadotecnia, publicidad o prospección comercial para ofrecerle otros de nuestros productos, servicios y promociones.',
  'Elaborar reportes internos sobre desempeño o calidad del servicio.'
]

export default {
  name: 'ComprehensivePrivacyNotice',
  data() {
    return {
      dataPoints: {
        personalData,
        primaryPurposes,
        secondaryPurposes
      }
    }
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    submit: {
      required: true,
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
    display: flex;
    flex-direction: column;

    .policy-text {
          flex-grow: 1;
    }
}
  .policy-title{
    word-break: break-word;
  }
.submit-btn {
    font-size: 24px;
    font-weight: 800;
}
</style>
